<template>
  <div :id="`comment_${id}`" class="comment mt-2">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-8">
            <blockquote class="comment-text m-0">
              {{ text }}
            </blockquote>
            <div class="comment-footer small-text">
              <span v-if="commenterDisplayName">
                {{ commenterDisplayName }}
              </span>
              <span class="date">
                <time :datetime="createdAt">
                  {{ timeAgo(createdAt) }}
                </time>
              </span>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="d-flex">
              <div class="justify-content-end">
                <unstyled-button :id="`like_comment_${id}`" class="like-comment action-button"
                                 :title="i18n.t('petitions.comments.comment.like')" @click="likeComment">
                  <i class="icon-heart" :class="{selected: likedByCurrentUser}" />
                </unstyled-button>
                <unstyled-button v-if="awaitingApproval" :id="`flag_comment_${id}`" class="flag-comment action-button"
                                 :title="i18n.t('petitions.comments.comment.flag')"
                                 @click="openFlagModal">
                  <i class="icon-flag" />
                </unstyled-button>
                <a :id="`link_to_comment_${id}`" class="comment-permalink action-button"
                   :title="i18n.t('petitions.comments.comment.permalink')"
                   :href="linkPath">
                  <i class="icon-link" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <comment-flag-modal v-if="showModal" :modal-id="`flag-comment-${id}`"
                        :comment-id="id" :petition-slug="petitionSlug"
                        @closed="flagModalClosed" />
  </div>
</template>

<script>
import ajax from '@/helpers/ajax'
import CommentFlagModal from './comment-flag-modal'
import Cookies from 'js-cookie'
import UnstyledButton from '@/components/buttons/unstyled-button'

export default {
  components: { CommentFlagModal, UnstyledButton },

  props: {
    awaitingApproval: {
      type: Boolean,
      required: true
    },
    commenterDisplayName: {
      type: String,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },

    // This needs to be passed in via prop to support the single-comment view which does not use a Vuex store.
    petitionSlug: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      cookie: null,
      showModal: false
    }
  },

  computed: {
    cookieForCommentLike() {
      return `agra-comment-${this.id}`
    },
    cookiePath() {
      // Cookie name has the comment id.
      // Cookie path name is the petition path so it's shared whether this is rendered on the
      // petition page or the comment permalink page.
      return `/petitions/${this.petitionSlug}`
    },
    flagPath() {
      return `/petitions/${this.petitionSlug}/comments/${this.id}/flags`
    },
    likedByCurrentUser() {
      return this.cookie === 'c'
    },
    likePath() {
      return `/petitions/${this.petitionSlug}/comments/${this.id}/like`
    },
    linkPath() {
      return `/petitions/${this.petitionSlug}/comments/${this.id}`
    }
  },

  mounted() {
    // Q: Why can't this be set in data()?
    // A: The computed property `cookieForCommentLike` isn't available at that time.
    this.cookie = Cookies.get(this.cookieForCommentLike)
  },

  methods: {
    flagModalClosed() {
      this.showModal = false
    },

    likeComment() {
      ajax.put({
        url: this.likePath,
        successHandler: () => {
          Cookies.set(this.cookieForCommentLike, 'c', { expires: 3, path: this.cookiePath })
          // Q: Could we make a computed property that reads the cookie instead of setting the cookie on the component data?
          // A: No, by default in Vue cookies are not reactive.
          this.cookie = Cookies.get(this.cookieForCommentLike)
        }
      })
    },

    openFlagModal() {
      this.showModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .comment {
    border-color: #ccc;

    .comment-text {
      border-left: none;
      padding: 10px 10px 5px 35px;
      font-size: 15px;
      line-height: 20px;

      &::before {
        content: '“';
        font-size: 50px;
        position: absolute;
        top: 20px;
        left: 20px;
      }
    }

    .comment-footer {
      padding: 0 0 10px 35px;
    }

    .action-button {
      margin-left: 15px;

      i {
        font-size: 14px;
        color: #333;
        opacity: 0.3;
      }

      &:hover,
      &:focus {
        text-decoration: none;

        i {
          opacity: 1;
        }
      }
    }

    i.icon-heart.selected {
      color: #cc3b3b;
    }
  }
</style>
